export const USER_AGREEMENT_VERSION = '2026-06-18';
export const USER_AGREEMENT_EFFECTIVE_DATE = '18 июня 2026';

export const USER_AGREEMENT_TITLE = 'Пользовательское соглашение и согласие на обработку персональных данных';
export const USER_AGREEMENT_SUBTITLE = 'для пользователей информационной системы "Большая Стирка"';

export const USER_AGREEMENT_INTRO = [
  'Настоящее соглашение регулирует доступ и работу сотрудников, подрядчиков и иных уполномоченных лиц в информационной системе "Большая Стирка". Документ предназначен для внутреннего использования и применяется к каждому пользователю, которому предоставлена учетная запись.',
  'Нажимая кнопку "Согласен", пользователь подтверждает, что ознакомлен с настоящим соглашением, понимает правила работы с персональными данными и обязуется соблюдать требования конфиденциальности, информационной безопасности и локальных актов оператора.'
];

export const USER_AGREEMENT_SECTIONS = [
  {
    title: 'Термины и правовой статус',
    paragraphs: [
      'Оператором является организация или индивидуальный предприниматель, использующие систему "Большая Стирка" для оказания услуг, учета заказов, управления сотрудниками и внутренними процессами.',
      'Пользователь получает доступ к системе только для выполнения трудовых, служебных или договорных обязанностей. Доступ не является личным сервисом пользователя и может быть ограничен, изменен или прекращен оператором.'
    ],
    bullets: [
      'Персональные данные - любая информация, относящаяся к прямо или косвенно определенному физическому лицу.',
      'Обработка персональных данных - сбор, запись, хранение, уточнение, использование, передача, блокирование, удаление и иные действия с такими данными.',
      'Конфиденциальная информация - данные клиентов, сотрудников, контрагентов, сведения о заказах, ценах, маршрутах, платежах, внутренних процессах и иная непубличная информация оператора.'
    ]
  },
  {
    title: 'Данные, с которыми работает пользователь',
    paragraphs: [
      'При выполнении обязанностей пользователь может получать доступ к персональным данным клиентов, представителей контрагентов, сотрудников и иных лиц. К таким данным могут относиться фамилия, имя, отчество, телефон, адрес, сведения о заказах, комментарии, фотографии, история взаимодействий, платежная и иная информация, необходимая для работы сервиса.',
      'Пользователь обязан обрабатывать такие данные только в пределах своих полномочий и только для целей, связанных с выполнением порученной работы.'
    ],
    bullets: [
      'запрещается просматривать данные из личного интереса или по просьбе третьих лиц;',
      'запрещается копировать, выгружать, фотографировать экран, пересылать или публиковать данные без разрешения оператора;',
      'запрещается передавать данные через личные мессенджеры, почту, облачные хранилища и другие каналы, если такой порядок не разрешен оператором;',
      'при ошибочной отправке, утрате доступа, подозрении на утечку или чужой вход в учетную запись пользователь обязан немедленно сообщить ответственному лицу.'
    ]
  },
  {
    title: 'Персональные данные пользователя',
    paragraphs: [
      'Для предоставления доступа, учета действий и организации работы оператор обрабатывает персональные данные самого пользователя. Обработка осуществляется в соответствии с Федеральным законом от 27.07.2006 N 152-ФЗ "О персональных данных", Трудовым кодексом РФ, договорами, локальными актами и иными применимыми основаниями.',
      'Согласие пользователя применяется к тем действиям с персональными данными, для которых по закону требуется согласие. Наличие согласия не отменяет право оператора обрабатывать данные на иных законных основаниях, например для исполнения трудового договора, договора с подрядчиком, обязанностей по закону, обеспечения безопасности и защиты прав оператора.'
    ],
    bullets: [
      'идентификационные данные: логин, фамилия, имя, отчество, телефон, роль, подразделение, права доступа;',
      'рабочие данные: назначенные заказы и поручения, статусы работ, комментарии, фотографии, операции с расходами и иные действия в системе;',
      'технические данные: дата и время входа, IP-адрес, user-agent, сведения об устройстве и браузере, push-подписки, журналы ошибок и активности;',
      'служебные данные: история изменения профиля, блокировки, восстановления доступа, принятия соглашения и сброса пароля.'
    ]
  },
  {
    title: 'Цели обработки данных пользователя',
    paragraphs: [
      'Оператор обрабатывает данные пользователя для предоставления и администрирования доступа к системе, распределения заказов и поручений, ведения учета работы, связи с пользователем, обеспечения безопасности, расследования инцидентов, расчета выплат или расходов, выполнения требований закона и защиты прав оператора, клиентов и иных лиц.',
      'Данные могут использоваться для формирования журналов действий, внутренней отчетности, подтверждения факта выполнения операций и разрешения спорных ситуаций.'
    ],
    bullets: []
  },
  {
    title: 'Безопасность учетной записи',
    paragraphs: [
      'Учетная запись является персональной. Пользователь отвечает за сохранность логина, пароля, устройства и иных средств доступа.'
    ],
    bullets: [
      'не передавать пароль и доступ другим лицам, включая коллег;',
      'использовать надежный пароль и не хранить его в открытом виде;',
      'выходить из учетной записи на чужих или общих устройствах;',
      'не обходить ограничения доступа, роли, блокировки и технические меры защиты;',
      'сообщать оператору о потере устройства, подозрении на компрометацию пароля или обнаружении чужих данных.'
    ]
  },
  {
    title: 'Журналы действий и контроль',
    paragraphs: [
      'Система фиксирует действия пользователя: входы, создание и изменение заказов, клиентов, услуг, расходов, поручений, настроек, комментариев, статусов и другие значимые операции. Такие журналы нужны для безопасности, учета, восстановления истории событий и разрешения спорных ситуаций.',
      'Пользователь понимает и соглашается, что сведения о его действиях в системе могут быть просмотрены уполномоченными лицами оператора и использованы в рамках внутренней проверки, служебного разбирательства, защиты прав, выполнения договора или требований закона.'
    ],
    bullets: []
  },
  {
    title: 'Конфиденциальность',
    paragraphs: [
      'Пользователь обязан сохранять конфиденциальность персональных данных и иной непубличной информации, полученной при работе в системе. Эта обязанность действует во время работы с оператором и после прекращения доступа, трудовых или договорных отношений.',
      'Раскрытие информации допускается только в пределах полномочий пользователя, по поручению оператора или в случаях, прямо предусмотренных законом.'
    ],
    bullets: []
  },
  {
    title: 'Запрещенные действия',
    paragraphs: [
      'Пользователю запрещается использовать систему способом, который может нарушить права клиентов, сотрудников, оператора или третьих лиц.'
    ],
    bullets: [
      'вносить недостоверные сведения или изменять данные без служебного основания;',
      'массово выгружать, копировать или анализировать данные вне рабочих задач;',
      'использовать доступ после прекращения полномочий или передавать его другим лицам;',
      'загружать вредоносные файлы, вмешиваться в работу системы или пытаться получить доступ к чужим разделам;',
      'использовать персональные данные для личных целей, рекламы, рассылок, конфликтов, давления или передачи третьим лицам.'
    ]
  },
  {
    title: 'Права пользователя как субъекта персональных данных',
    paragraphs: [
      'Пользователь вправе получать информацию об обработке своих персональных данных, требовать уточнения, блокирования или удаления данных в случаях, предусмотренных законом, а также отозвать согласие на обработку там, где обработка основана именно на согласии.',
      'Отзыв согласия не прекращает обработку, которая необходима оператору по закону, договору, для защиты прав, ведения учета, обеспечения безопасности или исполнения иных законных обязанностей.'
    ],
    bullets: []
  },
  {
    title: 'Ответственность',
    paragraphs: [
      'Нарушение настоящего соглашения может привести к ограничению или прекращению доступа к системе, дисциплинарной, материальной, гражданско-правовой, административной или уголовной ответственности в случаях, предусмотренных законом и договором.',
      'Пользователь несет ответственность за действия, совершенные под его учетной записью, если не докажет, что доступ был получен третьими лицами не по его вине и пользователь своевременно сообщил об инциденте оператору.'
    ],
    bullets: []
  },
  {
    title: 'Изменение соглашения',
    paragraphs: [
      'Оператор вправе обновлять соглашение при изменении закона, процессов, состава данных, технических средств или внутренних правил. При выпуске новой версии система может запросить повторное принятие соглашения.',
      'Факт принятия фиксируется в системе с указанием пользователя, версии документа, даты и технических сведений о событии.'
    ],
    bullets: []
  }
];

export const USER_AGREEMENT_CONTENT = [
  ...USER_AGREEMENT_INTRO,
  ...USER_AGREEMENT_SECTIONS.flatMap((section, index) => [
    `## ${index + 1}. ${section.title}`,
    ...section.paragraphs,
    ...section.bullets.map((item) => `- ${item}`)
  ])
].join('\n\n');

export const DEFAULT_USER_AGREEMENT_DOCUMENT = {
  version: USER_AGREEMENT_VERSION,
  title: USER_AGREEMENT_TITLE,
  subtitle: USER_AGREEMENT_SUBTITLE,
  content: USER_AGREEMENT_CONTENT,
  updated_date: null
};
